<script lang="ts" setup>
interface Props {
  isOpen: boolean
  message: string
}

defineProps<Props>()

const emit = defineEmits<{
  close: []
}>()

const closePopup = () => {
  emit('close')
}
</script>

<template>
  <Transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 px-4"
      @click="closePopup"
    >
      <div class="bg-white rounded-2xl p-8 md:p-12 max-w-md w-full shadow-2xl" @click.stop>
        <h3 class="text-2xl md:text-3xl font-bold text-center text-black">
          {{ message }}
        </h3>
      </div>
    </div>
  </Transition>
</template>

<style scoped></style>
